module.exports = __webpack_public_path__ + "img/main-logo.7a4ae3c3.svg";